import axios from 'axios'
import {handleError} from '../handleError'
import {LError} from '../../object'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  async submitConfig ({dispatch}, {config, type}) {
    let url = '/passObjectApi/global/order/config?orderType=' + type
    try {
      let res = null
      res = await axios.post(url, config)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async putConfig ({dispatch}, param) {
    let url = '/passObjectApi/order/config'
    try {
      let res = null
      res = await axios.put(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getCommonConfig ({dispatch}, param) {
    let url = '/passObjectApi/global/config?token=' + param
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getReservationConfigList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/order/config/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async getConfigListNew ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/order/config/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async getConfigList ({dispatch}, {pagination, orderType, ownerType}) {
    let url = '/passObjectApi/order/config/list?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, {
        'searchParam': {
          'ownerType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': ownerType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          },
          'orderType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': orderType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          }
        }
      })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getConfig ({dispatch}, {ownerType, ownerId, orderType}) {
    let url = '/passObjectApi/order/config/list?page=0&size=10'
    try {
      let res = null
      res = await axios.post(url, {
        'searchParam': {
          'ownerType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': ownerType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          },
          'ownerId': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': ownerId,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          },
          'orderType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': orderType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          }
        }
      })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getGroups ({dispatch}, {param, pagination}) {
    let url = '/shiroApi/group/list?page=' + pagination.page + '&size=' + pagination.rowsPerPage + '&type='
    try {
      let res = null
      res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getUsers ({dispatch}, {param, pagination}) {
    let url = '/shiroApi/user/list?page=' + pagination.page + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getGroupUsers ({dispatch}, {param, pagination, id}) {
    let url = '/shiroApi/group/' + id + '/user/list?page=' + pagination.page + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async deleteConfigs ({dispatch}, config) {
    let url = '/passObjectApi/order/config'
    try {
      let res = null
      res = await axios.delete(url, {data: config})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getReservationConfig ({dispatch}, type) {
    let url = '/passObjectApi/order/config/self?orderType=' + type
    try {
      let res = null
      res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getFinalConfig({dispatch},{type,userId}){
    let url = "/passObjectApi/order/config/self?orderType="+type+"&userId="+userId
    try {
      let res = await axios.post(url)
      return res
    }catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}
export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
